import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(main-layout)/empleos/IFrame.tsx")